/** @format */

import React from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import ArticleLayout from 'components/ArticleLayout';
import Container from 'react-bootstrap/Container';
import { LeadsSectionBody, LeadSources } from 'components/LeadsGenerator';

import './styles.scss';

export default function InvestArticlePage(props) {
  const text = props.t('lang_registration:invest_article');
  const { isMobileView } = props;

  return (
    <>
      <div className='main-container invest-article-page-container'>
        <Header {...props} />
        <div className='inner-container'>
          <Container>
            {/* Page content here */}
            <ArticleLayout
              text={text}
              isMobileView={isMobileView}
              banner={'images/invest-top.png'}
              subIcon={'images/invest-middle.png'}
              subIcon1={'images/invest-bottom.png'}
              showFocusButtons={true}>
              <LeadsSectionBody
                metadata={{
                  source: LeadSources.FM_INVEST
                }}
                showPropertyTypes={true}
                showUrgency={true}
                showTextInputs={true}
                showLeadTypes={true}
                showSquareMeterInput={true}
                showNumberOfRoomsInput={true}
                showAddressInput={true}
                showBrokerStatusSelector={true}
                {...props}
              />
            </ArticleLayout>
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
